import { useRef, type ReactNode } from 'react';
import { Plus } from 'lucide-react';
import { motion } from 'motion/react';
import { ADMIN_COLORS } from '@/features/admin/utils/adminAnimations';
import { haptic } from '@/utils/haptics';
import { sound } from '@/utils/sounds';
import { useMagnetic } from '@/hooks/useMagnetic';
import { useRipple } from '@/components/ui/Ripple';

interface CreateButtonProps {
  label: string;
  onClick: () => void;
  icon?: ReactNode;
  className?: string;
}

export function CreateButton({ label, onClick, icon, className }: CreateButtonProps) {
  const ref = useRef<HTMLButtonElement>(null);
  const { x, y, onMouseMove, onMouseLeave } = useMagnetic(ref, { strength: 8 });
  useRipple(ref);

  return (
    <motion.button
      ref={ref}
      whileTap={{ scale: 0.95 }}
      style={{
        x,
        y,
        backgroundColor: ADMIN_COLORS.surface,
        border: `1px solid ${ADMIN_COLORS.border}`,
        boxShadow: ADMIN_COLORS.shadow,
      }}
      onClick={() => {
        sound.pop();
        haptic.nudge();
        onClick();
      }}
      onMouseMove={onMouseMove}
      onMouseLeave={onMouseLeave}
      className={`relative overflow-hidden flex items-center gap-2 px-4 py-2 md:px-6 md:py-3 rounded-xl font-bold cursor-pointer glass-surface ${className ?? ''}`}
    >
      {icon ?? <Plus className="w-5 h-5" />}
      <span className="hidden md:inline">{label}</span>
    </motion.button>
  );
}
